export enum ModuleIdEnum {
  EI = "ei",
  OCR = "ocr",
  FLAME = "flame",
  ADMIN = "admin",
  AUDITS = "audits",
  CHECKIN = "checkin",
  REPORTS = "reports",
  EI_USER = "ei_user",
  EXPERTS = "experts",
  SETTINGS = "settings",
  FEEDBACK = "feedback",
  DASHBOARD = "dashboard",
  STRUCTURAL = "structural",
  EI_SUPPORT = "ei_support",
  MASTER_DATA = "master_data",
  SITE_CONFIG = "site_config",
  FIELD_SETUP = "field_setup",
  PERFORMANCE = "performance",
  CONNECTIONS = "connections",
  MODULE_CONFIG = "module_config",
  INSTALL_SHARE = "install_share",
  INDOOR_MAPPING = "indoor_mapping",
  ADMINISTRATION = "administration",
  USER_MANAGEMENT = "user_management",
  ROLE_MANAGEMENT = "role_management",
  SECURITY_MAPPING = "security_mapping",
  ACTION_MANAGEMENT = "action_management",
  CUSTOMER_JOB_SITES = "customer_job_sites",
  LOCATION_HIERARCHY = "location_hierarchy",
  MATERIAL_MANAGEMENT = "material_management",
  Structural_Guidance = "structural_guidance",
  PROCESS_SAFETY_ASSESMENT = "process_safety_assesment",
  Material_Control_Inventory = "materialControlInventory",
  TRAINING = "training",
}

export interface ModulesModel {
  id: string;
  icon?: string;
  order?: number;
  route?: string;
  module?: string;
  parentId?: string; // parent module ID if it's a submodule
  moduleName?: string;
}

export interface ModulesWithSubmodulesModel extends ModulesModel {
  submodules: ModulesWithSubmodulesModel[];
}
